import { ITableField } from 'shared/Table'
import { IProjectType, ProjectStagesMap } from '../../projectTypes.types'
import textUtils from 'utils/text.utils'
import { CheckpointsMap } from 'screens/Admin/ProjectCheckpoints/projectCheckpoints.types'
import durationUtils from '../../utils/durationUtils'

const projectTypesTableFields = (
  projectStagesMap: ProjectStagesMap,
  checkpointsMap: CheckpointsMap
): ITableField<IProjectType, keyof IProjectType | 'duration'>[] => [
  { key: 'id', getter: (item) => item.id.toString(), sortGetter: (item) => item.id, header: 'ID', width: '200px' },
  {
    key: 'name',
    getter: (item) => item.name.toString(),
    sortGetter: (item) => item.name,
    header: 'Название',
    width: '300px',
  },
  {
    key: 'duration',
    getter: (item) => {
      const duration = durationUtils.getProjectTypeDuration(item, projectStagesMap, checkpointsMap)
      return `${duration} ` + textUtils.declineWordDependingOnCount(duration, ['дней', 'день', 'дня'])
    },
    sortGetter: (_item) => 0,
    header: 'Длительность',
    width: '200px',
  },
  {
    key: 'projectStages',
    getter: (item) => item.projectStages.map((s) => projectStagesMap[s.projectStageId]?.name).join(', '),
    sortGetter: (item) => item.projectStages.length,
    header: 'Этапы проекта',
    width: '400px',
  },
]

export default projectTypesTableFields
